import React, { useState, useEffect, useRef } from 'react'
import { Col, Row, Input, Select, Radio, Checkbox, Tooltip, Table } from "antd";
import axios from "axios";
import { notifysuccess } from "../../../utils/toast";
import { notifyfailure } from "../../../utils/toast";
import { notifycatch } from "../../../utils/toast";
import Cookies from "js-cookie";
import configData from "../../../config/config.json";
import loaderIcon from "../../../assets/images/login-and-signup/loader.gif";
import { WithContext as ReactTags } from "react-tag-input";
import FullLoader from "../../../assets/images/full-page-loader.gif"
import zoneIcon from '../../../assets/images/icons/demand_icon.svg';
import backButton from '../../../assets/images/back_button_arrow.svg';
import { Link } from "react-router-dom";


const GamAutomationCreate = ({ handlePageViewChange }) => {

    const scrollToItem = (ref, offset = 80) => {
        if (ref && ref.current) {
            ref.current.style.scrollMarginTop = `${offset}px`;
            ref.current.scrollIntoView({ behavior: "smooth", block: "start" });
            setTimeout(() => {
                ref.current.style.scrollMarginTop = '';
            }, 500);
        }
    };

    useEffect(() => {
        const inputs = document.querySelectorAll('.ant-select-selection-search-input');

        inputs.forEach(input => {
            const handleInput = () => {
                const parent = input.closest('.ant-select-selection-search');
                if (input.value.length > 0) {
                    parent.classList.add('searching');
                } else {
                    parent.classList.remove('searching');
                }
            };

            input.addEventListener('input', handleInput);

            // Cleanup event listener on component unmount
            return () => {
                input.removeEventListener('input', handleInput);
            };
        });
    });

    useEffect(() => {
        let status = Cookies.get("token_xapads_ssp") ? true : false;
        if (status) {
            let token = Cookies.get("token_xapads_ssp");
            axios
                .get(configData.SERVER_URL + "zone/pubMinifiedList", {
                    headers: {
                        "Content-Type": "application/json",
                        "x-access-token": token,
                    },
                })
                .then((response) => {
                    setPublisherList(response.data.data);
                })
                .catch((error) => { });
        }

        axios
            .get(configData.SERVER_URL + "gam_auto/gamTemp", {
                headers: {
                    "Content-Type": "application/json",
                },
            })
            .then((response) => {
                setTemplateTypeOptions(response.data.data);
            })
            .catch((error) => { });

        axios
            .get(configData.SERVER_URL + "gam_auto/list", {
                headers: {
                    "Content-Type": "application/json",
                },
            })
            .then((response) => {
                if (response.data.data.length > 0) {
                    setChildMappingData(
                        response.data.data.map((obj) => ({
                            ...obj,
                            check: false,
                        }))
                    );

                }

                setLoadingChildMapping(false)
            })
            .catch((error) => { setLoadingChildMapping(false) });


    }, []);


    const [buttonProcessing, setButtonProcessing] = useState(false);

    const [selectedPublisher, setSelectedPublisher] = useState("");
    const [publisherIsRequiredError, setPublisherIsRequiredError] =
        useState(false);
    const [publisherList, setPublisherList] = useState([]);

    const [publisherType, setPublisherType] = useState("t1");
    const [publisherTypeOptions] = useState([{ label: "T1", value: "t1" }, { label: "T2", value: "t2" }]);

    function onChangePublisher(event) {
        setPublisherIsRequiredError(false);
        setSelectedPublisher(event);

        let status = Cookies.get("token_xapads_ssp") ? true : false;
        if (status) {
            let token = Cookies.get("token_xapads_ssp");
            axios
                .get(configData.SERVER_URL + "ops/gam/zonesByPub?publisherId=" + event?.split('-')[0], {
                    headers: {
                        "Content-Type": "application/json",
                        "x-access-token": token,
                    },
                })
                .then((response) => {
                    if (response.status === 200) {
                        if (response.data.data.zones.length > 0) {
                            setZoneIdIsRequiredError(false)
                            setZoneIdError(false)
                            setZoneId(response.data.data.zones.map(id => ({ id: id.toString(), text: id.toString(), className: '' })))
                        }

                        if (response.data.data.zones.length === 0) {
                            notifyfailure("No zones found for the selected publisher")
                            setZoneId([])
                        }

                    }
                })
                .catch((error) => {
                    notifyfailure("Error while fetching zones.")
                    setZoneId([])
                });
        }
    }

    function onChangePublisherType(event) {
        setPublisherType(event);
    }

    const preventDrag = (event) => { };
    const regexZone = /^\d*$/;
    const [zoneId, setZoneId] = useState([]);
    const [zoneIdError, setZoneIdError] = useState(false);
    const [zoneIdIsRequiredError, setZoneIdIsRequiredError] =
        useState(false);

    const handleAdditionZoneId = (tag) => {
        setZoneIdIsRequiredError(false);
        console.log(tag)

        if (!regexZone.test(tag.text)) {
            setZoneIdError(true);
        }
        setZoneId([...zoneId, tag]);
    };

    const handleDeleteZoneId = (i) => {
        setZoneId(zoneId.filter((tag, index) => index !== i));
        let tempZoneId = zoneId.filter((tag, index) => index !== i);

        let checkVal = 0;
        for (let i = 0; i < tempZoneId.length; i++) {
            if (!regexZone.test(tempZoneId[i].text)) {
                checkVal = 1;
            }
        }
        if (checkVal === 0) {
            setZoneIdError(false);
        } else {
            setZoneIdError(true);
        }

        if (zoneId.filter((tag, index) => index !== i).length === 0) {
            setZoneIdError(false);
            setZoneIdIsRequiredError(true);
        }
    };

    const handleBlurZoneId = (tag) => {
        if (tag.length > 0) {
            setZoneId([...zoneId, { id: tag, text: tag }]);
            if (!regexZone.test(tag)) {
                setZoneIdError(true);
            }
        }

        if (!(tag.length === 0 && zoneId.length === 0)) {
            setZoneIdIsRequiredError(false);
        }
    };


    const [minCpm, setMinCpm] = useState("");
    const [minCpmIsRequiredError, setMinCpmIsRequiredError] = useState(false);
    const [minCpmValueError, setMinCpmValueError] = useState(false);
    const [maxCpm, setMaxCpm] = useState("");
    const [maxCpmIsRequiredError, setMaxCpmIsRequiredError] = useState(false);
    const [maxCpmValueError, setMaxCpmValueError] = useState(false);
    const [maxGreaterThanMinError, setMaxGreaterThanMinError] = useState(false);


    function onChangeMinCpm(event) {
        if (/^\d*\.?\d*$/.test(event.target.value.trim())) {

            setMinCpm(event.target.value.trim());

            if (event.target.value.trim().length === 0) {
                setMinCpmValueError(false);
                setMaxGreaterThanMinError(false);
                setMinCpmIsRequiredError(true);
            } else {
                let minValCheck = 0;
                let maxValCheck = 50;

                if (
                    !(
                        event.target.value.trim() > minValCheck && event.target.value.trim() <= maxValCheck
                    )
                ) {
                    setMinCpmIsRequiredError(false);
                    setMaxGreaterThanMinError(false);
                    setMinCpmValueError(true);
                } else {
                    setMinCpmIsRequiredError(false);
                    setMaxGreaterThanMinError(false);
                    setMinCpmValueError(false);

                    if (maxCpm !== "") {
                        if (parseFloat(maxCpm) < parseFloat(event.target.value.trim())) {
                            setMinCpmIsRequiredError(false);
                            setMinCpmValueError(false);
                            setMaxGreaterThanMinError(true);
                        } else {
                            setMaxGreaterThanMinError(false);
                        }
                    }
                }
            }
        }
    }


    function onChangeMaxCpm(event) {
        if (/^\d*\.?\d*$/.test(event.target.value.trim())) {
            setMaxCpm(event.target.value.trim());

            if (event.target.value.trim().length === 0) {
                setMaxCpmValueError(false);
                setMaxGreaterThanMinError(false);
                setMaxCpmIsRequiredError(true);
            } else {
                let minValCheck = 0;
                let maxValCheck = 50;

                if (
                    !(
                        event.target.value.trim() > minValCheck && event.target.value.trim() <= maxValCheck
                    )
                ) {
                    setMaxCpmIsRequiredError(false);
                    setMaxGreaterThanMinError(false);
                    setMaxCpmValueError(true);
                } else {
                    setMaxCpmIsRequiredError(false);
                    setMaxGreaterThanMinError(false);
                    setMaxCpmValueError(false);

                    if (minCpm !== "") {
                        if (parseFloat(minCpm) > parseFloat(event.target.value.trim())) {
                            setMaxCpmIsRequiredError(false);
                            setMaxCpmValueError(false);
                            setMaxGreaterThanMinError(true);
                        } else {
                            setMaxGreaterThanMinError(false);
                        }
                    }
                }
            }
        }
    }

    const [templateType, setTemplateType] = useState("");
    const [templateTypeIsRequiredError, setTemplateTypeIsRequiredError] = useState(false);
    const [templateTypeOptions, setTemplateTypeOptions] = useState([]);

    function onChangeTemplateType(event) {
        setTemplateTypeIsRequiredError(false)
        setTemplateType(event);
    }


    const [vastChild, setVastChild] = useState("");
    const [vastChildIsRequiredError, setVastChildIsRequiredError] = useState(false);

    function onChangeVastChild(event) {
        setVastChildIsRequiredError(false)
        setVastChild(event.target.value);
    }



    //------------------------------------------------------------------------------------------//

    const [loadingChildMapping, setLoadingChildMapping] = useState(true);
    const [childMappingData, setChildMappingData] = useState([])
    const [childMappingDataIsRequiredError, setChildMappingDataIsRequiredError] = useState(false)
    const childMappingColumns = [
        {
            title: (
                <Checkbox
                    className='table_checkbox_d2'
                    indeterminate={childMappingData.some(item => item.check) && !childMappingData.every(item => item.check)}
                    checked={childMappingData.every(item => item.check)}
                    onChange={(e) => {
                        const checked = e.target.checked;
                        let tempData = childMappingData.map(obj => ({
                            ...obj,
                            check: checked,
                        }));

                        setChildMappingDataIsRequiredError(false)
                        setChildMappingData(tempData);
                    }}
                />
            ),
            dataIndex: 'check',
            key: 'check',
            width: 35,
            fixed: 'left',
            render: (text, record) => (
                <Checkbox
                    className='table_checkbox_d2'
                    // checked={true}
                    checked={text}
                    onChange={(e) => {
                        setChildMappingDataIsRequiredError(false)
                        const checked = e.target.checked;
                        let tempData = childMappingData.map(obj =>
                            obj._id === record._id ? { ...obj, check: checked } : obj
                        );

                        setChildMappingData(tempData);

                    }}
                />
            ),
        },
        // {
        //     title: 'ID',
        //     dataIndex: 'id',
        //     key: 'id',
        //     width: 100,
        //     // sorter: true,
        //     // sortDirections: ['ascend', 'descend', 'ascend'],
        //     // sorter: (a, b) => a.id - b.id,
        //     render: (text, record) => <div className="text_dark_800">{record.id}</div>,
        // },
        {
            title: 'Child Name',
            dataIndex: 'child_pub_name',
            key: 'child_pub_name',
            width: 230,
            render: (text) =>
                text.length > 30 ?
                    <Tooltip title={text}><div className="text_dark text_ellipsis text_black_d2 d-block">{text.slice(0, 30)}...</div></Tooltip> :
                    <div className="text_dark text_ellipsis text_black_d2 d-block">{text}</div>

        },
        {
            title: 'Whitelist',
            dataIndex: 'dsp_domain_lists',
            key: 'dsp_domain_lists',
            width: 280,
            render: (text) =>
                text.length > 40 ?
                    <Tooltip title={text}><div className="text_dark text_ellipsis text_black_d2 d-block">{text.slice(0, 40)}...</div></Tooltip> :
                    <div className="text_dark text_ellipsis text_black_d2 d-block">{text}</div>
        },

    ];

    const localeChildMapping = {
        emptyText:
            <>{
                loadingChildMapping &&
                <div className='no_data_screen'>
                    <div className='text-center'>
                        <img src={FullLoader} width={30} height={30} alt="USP" className="" />
                    </div>
                </div>
            }
            </>

    };

    //--------------------------------------------------------------------------------------------//

    //------------------------------------------------------------------------------------------//
    function validateChildMappingArray() {
        return childMappingData.some(obj => obj.check);
    }

    const publisherRef = useRef(null)
    const zoneRef = useRef(null)
    const templateTypeRef = useRef(null)

    const errorDetect = () => {
        if (selectedPublisher === "") {
            scrollToItem(publisherRef);
            return
        }

        if (zoneId.length === 0 || minCpm === "" || maxCpm === "" || minCpmValueError === true || maxCpmValueError === true || maxGreaterThanMinError === true) {
            scrollToItem(zoneRef);
            return
        }
        if (templateType === "") {
            scrollToItem(templateTypeRef);
            return
        }
    }

    const handleSubmit = async (e) => {
        e.preventDefault();

        errorDetect()

        if (
            selectedPublisher !== "" &&
            zoneId.length > 0 &&
            minCpm !== "" &&
            maxCpm !== "" &&
            templateType !== "" &&
            vastChild !== ""
        ) {
            if (
                publisherIsRequiredError === false &&
                zoneIdIsRequiredError === false &&
                minCpmIsRequiredError === false &&
                minCpmValueError === false &&
                maxCpmIsRequiredError === false &&
                maxCpmValueError === false &&
                maxGreaterThanMinError === false &&
                templateTypeIsRequiredError === false &&
                vastChildIsRequiredError === false
            ) {

                if (vastChild === true) {

                    if (!validateChildMappingArray()) {
                        setChildMappingDataIsRequiredError(true)
                        return

                    }

                }

                let payload = {
                    publisher: selectedPublisher?.split("-")[0],
                    type: publisherType,
                    zoneId: zoneId?.map(obj => obj.text),
                    minEcpm: minCpm,
                    maxEcpm: maxCpm,
                    template: templateType,
                    vastPerChild: vastChild,
                    creativeWhitelist: vastChild ? childMappingData?.filter(obj => obj.check)
                        .map(({ child_net_code, child_seller_id }) => ({ child_net_code, child_seller_id })) : []
                }

                setButtonProcessing(true)

                let status = Cookies.get("token_xapads_ssp") ? true : false;
                if (status) {

                    let token = Cookies.get("token_xapads_ssp");

                    axios
                        .post(configData.SERVER_URL + `gam_auto/createCamp`, payload, {
                            headers: {
                                'Content-Type': 'application/json',
                                "x-access-token": token,
                            },
                        })
                        .then((response) => {
                            notifysuccess(response.data.message);
                            handlePageViewChange("table", "yes")

                        })
                        .catch((error) => {
                            if (error?.response) {
                                if (error.response.data.message?.length !== 0) {
                                    notifyfailure(error.response.data.message);
                                    setButtonProcessing(false)
                                }
                            } else {
                                notifycatch();
                                setButtonProcessing(false)
                            }

                        });
                }

            }
        } else {

            if (selectedPublisher === "") {
                setPublisherIsRequiredError(true);
            }
            if (zoneId.length === 0) {
                setZoneIdIsRequiredError(true);
            }
            if (minCpm === "") {
                setMinCpmIsRequiredError(true)
            }
            if (maxCpm === "") {
                setMaxCpmIsRequiredError(true)
            }
            if (templateType === "") {
                setTemplateTypeIsRequiredError(true)
            }
            if (vastChild === "") {
                setVastChildIsRequiredError(true)
            }
        }
    };


    return (
        <>
            <div className="container_box--wrapper pt_header">
                <div className="container_box--breadcrumb">
                    <ul className="container_box--breadcrumb-list">
                        <li>
                            <Link onClick={() => {
                                handlePageViewChange("table", "no")
                            }}>
                                <img src={zoneIcon} alt="USP" /> Gam Automation
                            </Link>
                        </li>
                        <li className="primary"> Create Automation</li>
                    </ul>
                </div>
                <div className="container_box--wrapper--title">
                    <div className="back_btn_d2">
                        <img src={backButton} className="img-fluid" alt=""
                            onClick={() => {
                                handlePageViewChange("table", "no")
                            }}
                        />
                        <h1 className="heading">
                            Create Automation
                        </h1>
                    </div>
                </div>

                <div className="container_box--content pt_20">
                    <div className="container_box--width">
                        <Row gutter={16}>
                            <Col span={8}>
                                <div className="container_box--label-info">
                                    <label>Publisher</label>
                                    <p className="sub_text">Choose publisher account</p>
                                </div>
                            </Col>

                            <Col span={16}>
                                <div className="container_box--form-container" ref={publisherRef}>
                                    <Row gutter={16}>
                                        <Col span={18}>
                                            <div className="form_content_block--group mb_0 hide_caret_after_select_value">
                                                <label className="form_label">Publisher * </label>
                                                <Select
                                                    showSearch
                                                    optionFilterProp="label"
                                                    className={
                                                        publisherIsRequiredError
                                                            ? "form_select basic error"
                                                            : "form_select basic "
                                                    }
                                                    // open={true}
                                                    value={selectedPublisher}
                                                    onChange={onChangePublisher}
                                                    options={publisherList}
                                                />
                                            </div>
                                            <span className="error_content">
                                                {publisherIsRequiredError && (
                                                    <> This field is required</>
                                                )}
                                            </span>
                                        </Col>
                                        <Col span={6}>
                                            <div className="form_content_block--group mb_0 hide_caret_after_select_value">
                                                <label className="form_label">Type </label>
                                                <Select
                                                    showSearch={false}
                                                    optionFilterProp="label"
                                                    className="form_select basic no_search"
                                                    // open={true}
                                                    value={publisherType}
                                                    onChange={onChangePublisherType}
                                                    options={publisherTypeOptions}
                                                />
                                            </div>
                                            <span className="error_content">
                                                <></>
                                            </span>
                                        </Col>
                                    </Row>
                                </div>
                            </Col>

                        </Row>

                        <Row gutter={16}>
                            <Col span={8}>
                                <div className="container_box--label-info">
                                    <label>Zone</label>
                                    <p className="sub_text"></p>
                                </div>
                            </Col>

                            <Col span={16}>
                                <div className="container_box--form-container " ref={zoneRef}>
                                    <Row gutter={16}>
                                        <Col span={24}>
                                            <div

                                                className={zoneIdIsRequiredError || zoneIdError ? "form_content_block--group mb_0 hide_caret_after_select_value react_tag_design error " : "form_content_block--group mb_0 hide_caret_after_select_value react_tag_design  "} >
                                                <label className="form_label">Zone Id * </label>
                                                <ReactTags
                                                    className=""
                                                    tags={zoneId}
                                                    handleDrag={preventDrag}
                                                    handleDelete={handleDeleteZoneId}
                                                    handleAddition={handleAdditionZoneId}
                                                    handleInputBlur={handleBlurZoneId}
                                                    placeholder="Press enter to add new Zone Id"
                                                    autofocus={false}
                                                    allowDragDrop={false}
                                                />
                                            </div>
                                            <span className="error_content">
                                                {zoneIdIsRequiredError && (
                                                    <> This field is required
                                                        <br />
                                                    </>
                                                )}
                                                {zoneIdError && (
                                                    <> Zone id should be numeric</>
                                                )}
                                            </span>
                                        </Col>

                                    </Row>
                                </div>
                            </Col>

                        </Row>


                        <Row gutter={16}>
                            <Col span={8}>
                                <div className="container_box--label-info">
                                    <label>eCPM </label>
                                    <p className="sub_text">Choose eCPM Range</p>
                                </div>
                            </Col>

                            <Col span={16}>
                                <div className="container_box--form-container">
                                    <Row gutter={16}>
                                        <Col span={12}>
                                            <div className="form_content_block--group mb_0">
                                                <label className="form_label">eCPM Range (Min-Max) *</label>
                                                <Input className={minCpmIsRequiredError || minCpmValueError ? 'form_control basic error' : 'form_control basic'} placeholder='Min' autocomplete="off"
                                                    value={minCpm}
                                                    // onBlur={onBlurMinCpm}
                                                    onChange={onChangeMinCpm}
                                                />
                                            </div>
                                            <span className="error_content">

                                                {minCpmIsRequiredError && (
                                                    <>
                                                        This field is required
                                                        <br />
                                                    </>
                                                )}

                                                {minCpmValueError && (
                                                    <>
                                                        Value should be greater than 0 and less than or equal to 50
                                                    </>
                                                )}
                                            </span>
                                            <small className='line_between_cols_d2'>-</small>
                                        </Col>
                                        <Col span={12}>
                                            <div className="form_content_block--group mb_0">
                                                <label className="form_label invisible">eCPM range (Min-Max) *</label>
                                                <Input className={maxCpmIsRequiredError || maxCpmValueError || maxGreaterThanMinError ? 'form_control basic error' : 'form_control basic'} placeholder='Max' autocomplete="off"
                                                    value={maxCpm}
                                                    // onBlur={onBlurMaxCpm}
                                                    onChange={onChangeMaxCpm}
                                                />
                                                <span className="error_content">
                                                    {maxCpmIsRequiredError && (
                                                        <>
                                                            This field is required
                                                            <br />
                                                        </>
                                                    )}
                                                    {maxCpmValueError && (
                                                        <>
                                                            Value should be greater than 0 and less than or equal to 50
                                                            <br />
                                                        </>
                                                    )}
                                                    {maxGreaterThanMinError && (
                                                        <>
                                                            Max CPM Should be greater than or equal to Min
                                                            CPM
                                                            <br />
                                                        </>
                                                    )}


                                                </span>
                                            </div>
                                        </Col>

                                    </Row>
                                </div>
                            </Col>

                        </Row>

                        <Row gutter={16} >
                            <Col span={8}>
                                <div className="container_box--label-info">
                                    <label>Vast Details</label>
                                    <p className="sub_text"></p>
                                </div>
                            </Col>

                            <Col span={16}>
                                <div className="container_box--form-container mb_0" ref={templateTypeRef}>
                                    <Row gutter={16}>
                                        <Col span={24}>
                                            <div className={templateTypeIsRequiredError ? "form_content_block--group mb_0" : "form_content_block--group"}>
                                                <label className="form_label">Template * </label>
                                                <Select
                                                    showSearch={false}
                                                    optionFilterProp="label"
                                                    className={
                                                        templateTypeIsRequiredError
                                                            ? "form_select basic error no_search"
                                                            : "form_select basic no_search "
                                                    }
                                                    placeholder="-Select-"
                                                    value={templateType}
                                                    onChange={onChangeTemplateType}
                                                    options={templateTypeOptions}
                                                />
                                            </div>
                                            <span className="error_content">
                                                {templateTypeIsRequiredError && (
                                                    <> This field is required</>
                                                )}
                                            </span>
                                        </Col>
                                        <Col span={24} style={{ marginBottom: "0px", paddingBottom: "0px" }}>
                                            <div className={vastChild === true ? "form_content_block--group" : "form_content_block--group mb_0"}>
                                                <label className="form_label">
                                                    Vast Per Child *
                                                </label>
                                                <Radio.Group
                                                    onChange={onChangeVastChild}
                                                    value={vastChild}
                                                    className="form_radio equal_space"
                                                >
                                                    <Radio className="radio_btn" value={true}>
                                                        Yes
                                                    </Radio>
                                                    <Radio className="radio_btn" value={false}>
                                                        No
                                                    </Radio>
                                                </Radio.Group>
                                                {vastChildIsRequiredError && (
                                                    <span className="error_content">

                                                        <> This field is required</>

                                                    </span>
                                                )}
                                            </div>
                                        </Col>

                                        {vastChild === true &&

                                            <div className="table_content--box form_table_design_d2"
                                                style={{ paddingLeft: "10px", width: "99%" }}
                                            >
                                                <Table
                                                    columns={childMappingColumns}
                                                    dataSource={[...childMappingData].sort((a, b) => b.check - a.check)}
                                                    rowClassName={(record) => record.check ? 'table_row_checked_d2' : ''}
                                                    // onChange={onChange}
                                                    locale={localeChildMapping}
                                                    pagination={false}
                                                    scroll={{ x: '', y: 'calc(100vh - 35rem' }}
                                                />
                                                <span className="error_content">

                                                    {childMappingDataIsRequiredError && (
                                                        <>
                                                            Minimum 1 selection is required
                                                            <br />
                                                        </>
                                                    )}

                                                </span>
                                            </div>

                                        }

                                    </Row>
                                </div>
                            </Col>

                        </Row>
                    </div >

                    <div className="hr_custom mb_20"></div>
                    <div className="btn_group justify-content-end gap_8 pb_50">
                        {buttonProcessing ?
                            <>
                                <button className="w_120_d2 btn btn_white_outline w_fit_content"
                                    disabled
                                >
                                    Discard
                                </button>
                                <button
                                    className="w_120_d2 btn btn_primary w_fit_content loader"
                                >
                                    <span>Create</span>
                                    <img
                                        src={loaderIcon}
                                        alt="USP"
                                        className="loader_icon"
                                    />
                                </button>
                            </> :
                            <>
                                <button className="w_120_d2 btn btn_white_outline w_fit_content"
                                    onClick={() => {
                                        handlePageViewChange("table", "no")
                                    }}
                                >
                                    Discard
                                </button>
                                <button className="w_120_d2 btn btn_primary w_fit_content"
                                    onClick={handleSubmit}
                                >Create</button>
                            </>
                        }

                    </div>


                </div >



            </div >
        </>
    )
}

export default GamAutomationCreate
